import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router} from "react-router-dom";
import PageRoutes from './Components/Pages/PageRoutes/PageRoutes';
import { ToastProvider } from './Contexts/ToastContext';

function App() {
  return (
    <ToastProvider>
    <Router>
        <PageRoutes/>
    </Router>
    </ToastProvider>
  );
}

export default App;
